import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Button } from '@cian/button-component';
import { Link } from '@cian/link-component';
import * as React from 'react';
import { EEventType } from '../../types/events';
import { EKeyCode } from '../../types/keyCodes';
import { EActiveView } from '../../types/view';
import { ESendSmsStatus, EConfirmPhoneStatus } from '../../types/registration';
import { ESentEmailType } from '../../types/sentEmail';
import { FormItem } from '../FormItem';
import { Timer } from '../Timer';
import * as styles from './styles.css';
import { trackConfirmPhoneConfirmClick, trackConfirmPhoneResendClick, trackConfirmPhoneShown } from '../../utils/tracking';
export var ConfirmPhoneView = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfirmPhoneView, _React$Component);

  var _super = _createSuper(ConfirmPhoneView);

  function ConfirmPhoneView(props) {
    var _this;

    _classCallCheck(this, ConfirmPhoneView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "codeField", void 0);

    _defineProperty(_assertThisInitialized(_this), "handleCodeKeyDown", function (event) {
      if (event.keyCode === EKeyCode.Enter) {
        _this.submit();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleCodeValueChange", function (code) {
      _this.setState({
        code: code,
        isChanged: true,
        isInvalid: !code || code.length < 4
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmitClick", function (event) {
      event.preventDefault();
      trackConfirmPhoneConfirmClick();

      _this.submit();
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      var _this$props = _this.props,
          _this$props$viewData = _this$props.viewData,
          email = _this$props$viewData.email,
          phone = _this$props$viewData.phone,
          confirmPhone = _this$props.confirmPhone,
          emit = _this$props.emit;
      var code = _this.state.code;

      _this.setState({
        isChanged: false,
        isInvalid: false
      });

      confirmPhone({
        email: email,
        phone: phone,
        code: code
      });
      emit(EEventType.ConfirmPhoneConfirmClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleTimeout", function () {
      _this.setState({
        codeResendAvailable: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleResendClick", function (event) {
      event.preventDefault();
      trackConfirmPhoneResendClick();
      var _this$props2 = _this.props,
          _this$props2$viewData = _this$props2.viewData,
          phone = _this$props2$viewData.phone,
          email = _this$props2$viewData.email,
          status = _this$props2.registration.sendSms.status,
          sendSms = _this$props2.sendSms,
          emit = _this$props2.emit;

      if (status !== ESendSmsStatus.Succeed) {
        return;
      }

      _this.setState({
        isChanged: true,
        isInvalid: false,
        code: ''
      });

      sendSms({
        email: email,
        phone: phone
      });
      emit(EEventType.ConfirmPhoneResendClick);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancelClick", function (event) {
      event.preventDefault();
      var _this$props3 = _this.props,
          changeView = _this$props3.changeView,
          emit = _this$props3.emit;
      changeView(EActiveView.EmailSent, {
        type: ESentEmailType.Registration
      });
      emit(EEventType.ConfirmPhoneCancelClick);
    });

    var _props$registration = props.registration,
        _sendSms = _props$registration.sendSms,
        _confirmPhone = _props$registration.confirmPhone;
    _this.state = {
      code: '',
      isChanged: _sendSms.status === ESendSmsStatus.Failed || _confirmPhone.status === EConfirmPhoneStatus.Failed,
      isInvalid: false,
      codeSentDate: new Date(),
      codeResendAvailable: false
    };
    _this.codeField = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(ConfirmPhoneView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.codeField.current) {
        this.codeField.current.focus();
      }

      trackConfirmPhoneShown();
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.registration.sendSms.status !== nextProps.registration.sendSms.status) {
        switch (nextProps.registration.sendSms.status) {
          case ESendSmsStatus.Failed:
            this.setState({
              codeSentDate: undefined,
              codeResendAvailable: undefined
            });
            break;

          case ESendSmsStatus.Succeed:
            this.setState({
              codeSentDate: new Date(),
              codeResendAvailable: false
            });
            break;
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.registration.sendSms.status !== this.props.registration.sendSms.status) {
        if (this.props.registration.sendSms.status === ESendSmsStatus.Succeed) {
          if (this.codeField.current) {
            this.codeField.current.focus();
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          viewData = _this$props4.viewData,
          _this$props4$registra = _this$props4.registration,
          sendSms = _this$props4$registra.sendSms,
          confirmPhone = _this$props4$registra.confirmPhone;
      var _this$state = this.state,
          code = _this$state.code,
          codeSentDate = _this$state.codeSentDate,
          codeResendAvailable = _this$state.codeResendAvailable,
          isChanged = _this$state.isChanged,
          isInvalid = _this$state.isInvalid;
      var isDisabled = sendSms.status === ESendSmsStatus.Loading || confirmPhone.status === EConfirmPhoneStatus.Loading;
      var isError = (confirmPhone.status === EConfirmPhoneStatus.Failed || sendSms.status === ESendSmsStatus.Failed && confirmPhone.status === EConfirmPhoneStatus.Succeed) && !isChanged;
      var error = isError ? confirmPhone.status === EConfirmPhoneStatus.Failed ? confirmPhone.error : sendSms.error : undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: styles['container']
      }, /*#__PURE__*/React.createElement("h2", {
        className: styles['header']
      }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043D\u043E\u043C\u0435\u0440\u0430"), /*#__PURE__*/React.createElement("p", {
        className: styles['description']
      }, "\u041D\u0430 \u043D\u043E\u043C\u0435\u0440 ", /*#__PURE__*/React.createElement("strong", null, formatPhone(viewData.phone)), " \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u0441\u043C\u0441 \u0441 \u043F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u044B\u043C \u043A\u043E\u0434\u043E\u043C."), /*#__PURE__*/React.createElement("form", {
        action: "#"
      }, /*#__PURE__*/React.createElement("div", {
        className: styles['code_row']
      }, /*#__PURE__*/React.createElement(FormItem, {
        ref: this.codeField,
        id: "confirm_phone-phone",
        name: "phone",
        label: "\u041F\u0440\u043E\u0432\u0435\u0440\u043E\u0447\u043D\u044B\u0439 \u043A\u043E\u0434 \u0438\u0437 \u0441\u043C\u0441",
        value: code,
        numeric: true,
        maxLength: 10,
        invalid: isError || isInvalid,
        error: isError ? error : undefined,
        disabled: isDisabled,
        onKeyDown: this.handleCodeKeyDown,
        onValueChange: this.handleCodeValueChange
      }), codeSentDate ? /*#__PURE__*/React.createElement("div", {
        className: styles['code_timer']
      }, !codeResendAvailable ? /*#__PURE__*/React.createElement("span", null, "\u0412\u044B\u0441\u043B\u0430\u0442\u044C \u043A\u043E\u0434 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437", ' ', /*#__PURE__*/React.createElement(Timer, {
        start: codeSentDate,
        timeout: 60,
        onTimeout: this.handleTimeout
      }), " \u0441\u0435\u043A.") : /*#__PURE__*/React.createElement(Link, {
        href: "#",
        onClick: this.handleResendClick
      }, "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E")) : null), /*#__PURE__*/React.createElement("div", {
        className: styles['submit_row']
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        disabled: !code,
        isSync: isDisabled,
        onClick: this.handleSubmitClick
      }, "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C"), /*#__PURE__*/React.createElement(Link, {
        href: "#",
        className: styles['cancel'],
        onClick: this.handleCancelClick
      }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"))));
    }
  }]);

  return ConfirmPhoneView;
}(React.Component);

function formatPhone(phone) {
  return "+".concat(phone.replace(/\D+/g, '').replace(/(\d)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5'));
}